import * as Types from './types';

export function setCompaniesById(payload) {
  return {
    type: Types['SET_COMPANIES'],
    payload,
  };
}

export function setCompanyTokenRefreshing(isRefreshing) {
  return {
    type: Types['SET_COMPANY_TOKEN_REFRESHING'],
    isRefreshing,
  };
}

export function setCompanyDataTables(payload) {
  return {
    type: Types['SET_COMPANY_DATA_TABLES'],
    payload,
  };
}

export function setLPDataInitialized(isInitialized) {
  return {
    type: Types['SET_LP_DATA_INITIALIZED'],
    isInitialized,
  };
}

export function setSharedReports(payload) {
  return {
    type: Types['SET_SHARED_REPORTS'],
    payload,
  };
}

export function setShouldRedirectFromEntitySelect(shouldRedirect) {
  return {
    type: Types['SET_SHOULD_REDIRECT_FROM_ENTITY_SELECT'],
    shouldRedirect,
  };
}
